/**
 * Centralized configuration for all DreamChimney v2 API endpoints
 */

const BASE_URL = `https://www.dreamchimney.com/api`;

export const apiConfig = {
  base: BASE_URL,

  // User endpoints
  user: {
    validate: `${BASE_URL}/user/validate`,
  },

  // OfTheDay endpoints
  oftheday: {
    submit: `${BASE_URL}/oftheday/submit`,
    delete: `${BASE_URL}/oftheday`,
    today: `${BASE_URL}/oftheday/today`,
    yesterday: `${BASE_URL}/oftheday/yesterday`,
    twodaysago: `${BASE_URL}/oftheday/twodaysago`,
    date: `${BASE_URL}/oftheday/date/`,
    recent: `${BASE_URL}/oftheday/recent`,
    search: `${BASE_URL}/oftheday/search`,
    detail: `${BASE_URL}/oftheday/detail`,
    related: `${BASE_URL}/oftheday/related`,
    profile: `${BASE_URL}/oftheday/profile/`,
    comment: `${BASE_URL}/oftheday/detail/comment`,
    tags: {
      search: `${BASE_URL}/oftheday/tags/search`,
      recent: `${BASE_URL}/oftheday/tags/recent`,
      slug: `${BASE_URL}/oftheday/tag/slug/`,
    },
  },
};

export default apiConfig;

